/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('CollisParserServiceApi', ($http, ApiErrorService) => {
    return {
        treeview: treeview
    };
    function treeview(traceId) {
        return $http.get(`api/CollisParser/Treeview?traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
